import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { common } from '../common'
import CategoryGroup from '../menu/category-group'
import List from '../menu/list'
import Link from '../menu/link'
import Dropdown from '../dropdown/index'
import { CategoryInfo } from './Types'
import Icon from '../assets'

interface Props {
  name: string
  categories: CategoryInfo[]
  showHome: boolean
  showRecentlyActive: boolean
  showUnanswered: boolean
  showActivitySinceLastVisit: boolean
  showKnowledgeBaseOverview: boolean
}

const CategoryMenu = ({ categories, showActivitySinceLastVisit, name, showHome, showRecentlyActive, showUnanswered, showKnowledgeBaseOverview }: Props) => (
  <li class='header-navigation_list-item main-menu'>
    <Dropdown
      popupName={showHome ? 'community-categories' : 'knowledgebase-categories'}
      class='dropdown dropdown--forums-overview'
      trigger={
        <span style={{ display: 'flex', alignItems: 'center' }} class='main-menu-trigger'>
          <span>{name}</span>
          <Icon icon='chevronDown' width={16} height={16} />
        </span>
      }
    >
      <li aria-hidden='true' class='arrow is-hidden-S' />

      <li class='main-menu-list--overflow-scroll'>
        {
          (showHome || showRecentlyActive || showActivitySinceLastVisit || showUnanswered || (common.isModuleActive('knowledgeBaseOverviewOpenForAllUsers') && showKnowledgeBaseOverview)) && (
            <List class='main-menu-list--quiclinks'>
              {
                  common.isModuleActive('knowledgeBaseOverviewOpenForAllUsers') && showKnowledgeBaseOverview && (
                    <Link href='/knowledge-base'>
                      <Phrase m='Forum' p='nav.title.knowledgebase' />
                    </Link>
                  )
              }

              {
                showHome && (
                  <Link href='/'>
                    <Phrase m='Common' p='nav.title.forum.overview' />
                  </Link>
                )
              }

              {
                showRecentlyActive && (
                  <Link
                    href='/search/activity/recent'
                  >
                    <Phrase m='Common' p='nav.title.forum.recent.activity' />
                  </Link>
                )
              }

              {
                showActivitySinceLastVisit && (
                  <Link
                    href='/search/activity/sincelastvisit'
                  >
                    <Phrase m='Common' p='nav.title.forum.activity.last.visit' />
                  </Link>
                )
              }

              {
                showUnanswered && (
                  <Link
                    href='/search/activity/unanswered'
                  >
                    <Phrase m='Common' p='nav.title.forum.unanswered.questions' />
                  </Link>
                )
              }
            </List>
          )
        }

        {categories.length
          ? (
            <ul>
              {categories.map(parentCategory => {
                return (
                  <CategoryGroup
                    key={parentCategory.id}
                    url={parentCategory.url}
                    title={parentCategory.title}
                    categories={parentCategory.subforums}
                  />
                )
              })}
            </ul>
            )
          : null}
      </li>
    </Dropdown>
  </li>
)

export default CategoryMenu
